import { render, staticRenderFns } from "./room-rent-list.vue?vue&type=template&id=6258734f"
import script from "./room-rent-list.vue?vue&type=script&lang=js"
export * from "./room-rent-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports